// extracted by mini-css-extract-plugin
export default {"container":"Container_container__GhCw0","narrow":"Container_narrow__a+LzY","wide":"Container_wide__tVtya"};